"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ToolTipStyled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var Wrapper = exports.Wrapper = _styledComponents["default"].li(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  :first-of-type {\n    margin-left: 0;\n  }\n  :last-of-type {\n    margin-right: 0;\n  }\n  margin-left: 5px;\n  margin-right: 5px;\n  margin-top: 0;\n  cursor: ", ";\n  padding: 0;\n  background: url(", ");\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  color: #dcdfec;\n  height: 45px;\n  width: 96px;\n  list-style-type: none;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  border-radius: 2px;\n  border: 1px solid ", ";\n  opacity: ", ";\n  position: relative;\n"])), function (props) {
  return props.available && (props.enableFeature || props.isStudioLite) ? 'pointer' : 'not-allowed';
}, function (props) {
  return props.thumbnail;
}, function (props) {
  return props.selected ? 'white' : 'transparent';
}, function (props) {
  return props.available ? '1' : '0.5';
});
var ToolTipStyled = exports.ToolTipStyled = {
  color: '#000',
  backgroundColor: '#fff'
};